import React, { useState } from 'react';
import DynaModal from '../../../Modal/DynaModal';
import './UploadExcelModal.scss';
import DynaDatePicker from '../../../A13/DynaView/DynaDatePicker';
import XLSX from 'xlsx';
import { toast } from "react-toastify";

const UploadExcelModal = ({ onClose, onExcelSubmit, maxDate, initialData }) => {
  const [entryDate, setEntryDate] = useState("");
  const [fileData, setFileData] = useState(null);
  const [fileName, setFileName] = useState("");
  const [isDragging, setIsDragging] = useState(false);

  const requiredHeaders = ["کد کالا", "نام کالا", "ارزش کالا"];

  const handleFileChange = (file) => {
    if (!file) return;

    // اعتبارسنجی نوع فایل بر اساس پسوند (.xlsx یا .xls)
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
      toast.error("فایل آپلود شده باید با فرمت اکسل باشد!");
      return;
    }

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = evt.target.result;
      let workbook = XLSX.read(data, { type: 'binary' });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      if (jsonData.length === 0) {
        toast.error("فایل اکسل خالی است!");
        return;
      }

      // اعتبارسنجی ستون‌های ضروری
      const headers = Object.keys(jsonData[0]);
      const missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
      if (missingHeaders.length > 0) {
        toast.error(`برخی از ستون‌های ضروری در فایل یافت نشدند: ${missingHeaders.join(" , ")}`);
        return;
      }

      // اعتبارسنجی مقادیر ارزش کالا
      const invalidValues = jsonData.filter(row => {
        const value = row["ارزش کالا"];
        return value === "" || isNaN(value) || Number(value) < 0;
      });

      if (invalidValues.length > 0) {
        toast.error("مقدار ستون ارزش کالا باید یک عدد معتبر (بزرگ‌تر از صفر) باشد. لطفاً اطلاعات فایل را بررسی کنید");
        return;
      }

      // اعتبارسنجی یونیک بودن کد کالا
      const codeSet = new Set();
      const duplicateCodes = jsonData.filter(row => {
        const code = row["کد کالا"];
        if (codeSet.has(code)) {
          return true;
        }
        codeSet.add(code);
        return false;
      });

      if (duplicateCodes.length > 0) {
        toast.error("برخی از کد کالاها در فایل تکراری هستند. لطفاً اطمینان حاصل کنید که هر کالا دارای یک کد منحصربه‌فرد است");
        return;
      }

      // اگر همه چیز درست بود، داده‌ها را ذخیره کنید
      setFileData(jsonData);
      setFileName(file.name);
      toast.success("فایل اکسل با موفقیت بارگذاری شد");
    };
    reader.readAsBinaryString(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleFileChange(file);
  };

  const handleSubmit = () => {
    if (!entryDate) {
      toast.error("لطفا تاریخ ورود را انتخاب کنید.");
      return;
    }
    if (!fileData) {
      toast.error("لطفا یک فایل اکسل معتبر انتخاب کنید.");
      return;
    }
    // ارسال داده‌ها به کامپوننت اصلی
    onExcelSubmit(entryDate, fileData);
    onClose();
  };

  const downloadTemplate = () => {
    if (!initialData || initialData.length === 0) {
      toast.error("داده‌ای برای ایجاد فرمت وجود ندارد!");
      return;
    }

    const formattedData = initialData.map(item => ({
      "کد کالا": item.id,
      "نام کالا": item.title,
      "ارزش کالا": ""
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "فرمت_ورود_اکسل.xlsx");
  };

  return (
    <DynaModal onClose={onClose} className={'simple-modal-saden upload-excel-modal'}>
      <div className="upload-excel-title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="12"
          fill="none"
          viewBox="0 0 10 12"
        >
          <path
            fill="#FFD62E"
            d="M1 7.732c-1.333-.77-1.333-2.694 0-3.464L7 .804c1.333-.77 3 .192 3 1.732v6.928c0 1.54-1.667 2.502-3 1.732z"
          ></path>
        </svg>
        <h3>ورود از اکسل</h3>
      </div>

      <div className='upload-excel-body'>
        <DynaDatePicker
          label={"تاریخ ورود"}
          name={"entryDate"}
          maxDate={maxDate}
          className={"solid-dyna-input"}
          value={entryDate}
          setDataFromComponent={(data) => setEntryDate(data.entryDate)}
        />
        <div
          className={`upload-box ${isDragging ? 'dragging' : ''}`} onDragOver={handleDragOver}
          onDragEnter={handleDragEnter} onDragLeave={handleDragLeave} onDrop={handleDrop}>

          <div className={`upload-content ${isDragging ? 'dragging' : ''}`}>
            <span>{fileName ? fileName : "فایل مورد نظر را بارگزاری کنید"}</span>
            <button onClick={() => document.getElementById("excel-file-input").click()}>
              انتخاب فایل
            </button>
            <input
              id="excel-file-input"
              type="file"
              accept=".xlsx,.xls"
              style={{ display: 'none' }}
              onChange={(e) => handleFileChange(e.target.files[0])}
            />
          </div>

        </div>
        <div className="download-template">
          <button onClick={downloadTemplate}>دانلود فرمت ورود اکسل</button>
        </div>
      </div>

      <div className='upload-excel-line'></div>

      <div className='upload-excel-end'>
        <div className="modal-buttons">
          <button onClick={onClose} className="cancel-button">انصراف</button>
          <button onClick={handleSubmit} className="submit-button">ثبت</button>
        </div>
      </div>
    </DynaModal>
  );
};

export default UploadExcelModal;